import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CreditsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Credits",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M16 32.06C7.15 32.06-.06 24.85-.06 16S7.15-.06 16-.06 32.06 7.14 32.06 16 24.86 32.06 16 32.06m0-29.83C8.41 2.23 2.23 8.41 2.23 16S8.41 29.77 16 29.77 29.77 23.59 29.77 16 23.59 2.23 16 2.23"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16 27.47C9.68 27.47 4.53 22.33 4.53 16a1.14 1.14 0 1 1 2.28 0c0 5.06 4.12 9.18 9.18 9.18a1.14 1.14 0 1 1 0 2.28ZM23.7 10.26c-.31 0-.63-.13-.85-.38a9.17 9.17 0 0 0-6.84-3.06 1.14 1.14 0 1 1 0-2.28c3.26 0 6.37 1.39 8.55 3.82a1.14 1.14 0 0 1-.85 1.9Z"
    })]
  }));
};